import { Filter } from '@anytag/shared-molecules';
import { Template, TemplateProps } from './Template';
import { useAssociatedAccountsFilter } from './hooks';

export type AssociatedAccountsFilterProps = Omit<TemplateProps, 'onSubmit'>;

export const AssociatedAccountsFilter = ({ keywordPlaceholder }: AssociatedAccountsFilterProps) => {
  const { filter, setFilterForm } = useAssociatedAccountsFilter();

  return (
    <Filter.Provider onSubmit={setFilterForm} values={filter} className="rounded-none p-4">
      <Template keywordPlaceholder={keywordPlaceholder} />
    </Filter.Provider>
  );
};

export { useAssociatedAccountsFilter };
export * from './schemaTypes';
